import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/contract/_list/_placeholders/contract-and-cost')({
  component: RouteComponent
});
function RouteComponent() {
  return <ComingSoonCover disableBlurBackdrop={true} />;
}